
  import React from "react"
  import Component from "/Users/daniloradovic/Desktop/coinis/webb-holding/src/layouts/index.js"
  import data from "/Users/daniloradovic/Desktop/coinis/webb-holding/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js